import { ResponseMessage } from "../clients/response-message";

export class BadRequestError extends Error {
    readonly response: ResponseMessage;

    constructor(message: string, response: ResponseMessage) {
        super(message);
        Object.setPrototypeOf(this, new.target.prototype);
        this.response = response;
    }
}
